import { render, staticRenderFns } from "./PartCard.vue?vue&type=template&id=67e3b583&scoped=true&"
import script from "./PartCard.vue?vue&type=script&lang=js&"
export * from "./PartCard.vue?vue&type=script&lang=js&"
import style0 from "./PartCard.vue?vue&type=style&index=0&id=67e3b583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e3b583",
  null
  
)

export default component.exports